<template>
    <div class="main">
        <div class="main-left">
            <div class="main-left-header">账号中心</div>
            <ul class="main-left-content">
                <li v-for="li in menuList" :class="li.isSelected?'selectli':'unselectli'" @click="clickLi(li.id)">{{li.title}}</li>
            </ul>
        </div>
        <div class="main-right">
            <div>
                <div class="popalert" v-show="isShowTopMsg">
                    <Alert closable type="warning" show-icon>特别提示：请及时关注微信公众号“众智云擎税法检索”, 即时精准获取税法文件智能推送。戳我扫码并关注
                        <Poptip placement="right">
                            <Button type="text" style="box-shadow: none;background-color: transparent;color:green;position: relative;top:-1px;" size="small">众智云擎公众号</Button>
                            <div class="api" slot="content">
                                <img style="width:200px;height: 200px;" src="../../assets/images/zzyq_qrcode.jpg">
                            </div>
                        </Poptip>
                    </Alert>
                </div>
                <div v-if="selectli.id==='1001'">
                    <MyVip />
                </div>
                <div v-else-if="selectli.id==='1002'">
                    <Order />
                </div>
                <div v-else-if="selectli.id==='1003'">
                    <ManaInvoice />
                </div>
                <div v-else-if="selectli.id==='1004'">
                    <ManaAgreement />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import order from './order.vue'
import myvip from './myvip.vue'
import myinvoice from './myinvoice.vue'
import downloadinvoice from './download_invoice.vue'
import downloadagreement from './download_contract.vue'
export default {
    data() {
        return {
            isShowTopMsg: true,
            menuList: [{
                id: '1001',
                title: '我的账号',
                isSelected: true
            }, {
                id: '1002',
                title: '我的订单',
                isSelected: false
            }, {
                id: '1003',
                title: '我的发票',
                isSelected: false
            }, {
                id: '1004',
                title: '我的协议',
                isSelected: false
            }],
            selectli: {
                id: '1001',
                title: '我的账号',
                isSelected: true
            },
        }
    },
    methods: {
        closeAlaert() {
            this.isShowTopMsg = false
        },
        clickLi(id) {
            this.menuList.forEach(function(item) {
                item.isSelected = false
            })
            let li = this.menuList.find(p => p.id === id)
            li.isSelected = true
            this.selectli = li
            //console.log(id);
        }
    },
    components: {
        'Order': order,
        'MyVip': myvip,
        'MyInvoice': myinvoice,
        "ManaInvoice": downloadinvoice,
        "ManaAgreement": downloadagreement,
    }
}
</script>
<style lang="less" scoped>
.popalert {
    background: #fff;
    width: 98%;
    padding: 10px;
    margin: 0 auto;
}

.popalert/deep/.ivu-icon {
    position: relative;
    top: 5px
}

.popalert/deep/.ivu-alert-close {
    top: 4px
}

.popalert/deep/.ivu-alert {
    margin-bottom: 0px;
}

.main {
    height: 89vh;
    display: flex;
}

.main-left {
    width: 200px;
}

.main-left-header {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    margin: 0 auto;
    padding: 20px 0;
    margin-bottom: 15px;
    line-height: 24px;
    border-bottom: 1px solid #eaedf2;

    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #2d8cf0;

}

.main-left-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 14px;
    text-align: center;
}

.main-left-content li {
    width: 100%;
    height: 20px;
    line-height: 20px;
    margin: 20px -10px;
    color: #6c727d;
    cursor: pointer;
    text-align: center;
    display: list-item;
    font-size: 14px;
    font-family: Source Han Sans CN;
    &:hover {
        color: #69f;
    }
}

.unselectli {
    color: #69f;
    border-right: 5px solid #fff;
    line-height: 20px;
}

.selectli {
    color: #69f !important;
    border-right: 5px solid #69f;
    line-height: 20px;
}

.main-right {
    flex: 1;
    background-color: #eff1f6;
    height: 89vh;
    overflow-y: auto;
}
</style>